{
  "display_name": "Andre",
  "household_name": "Andre's household",
  "portfolio_url": "https://dev.hearthfire.ai/portfolio",
  "sleeve_count": "3",
  "summary": "• US equities: 68% actual vs 60% target (+8 pp)\n• Intl equities: 12% actual vs 20% target (-8 pp)\n• Bonds: 12% actual vs 15% target (-3 pp)",
  "warn_pp": "5"
}
